import { GruppeTier } from '../classes/gruppe-tier';

export class GruppeTierAussendienstDialogInput {
    gruppeTiere: GruppeTier[] = [];
    anzahlTiere: number;
}

export class GruppeTierAussendienstDialogOutput {
    aussendienst: string;
}
